import { useEffect, useState } from 'react';
import { api, type Schemas } from '../api/client';

type Lookups = Schemas['LookupsResponse'];

// Ciselniky se behem sezeni nemeni - staci je nacist jednou pro celou aplikaci.
// Neuspesne nacteni se nepamatuje: dalsi stranka to zkusi znovu, ne az po F5.
let cached: Promise<Lookups | null> | null = null;

export function useLookups(): Lookups | null {
  const [lookups, setLookups] = useState<Lookups | null>(null);

  useEffect(() => {
    cached ??= api.GET('/api/v1/lookups').then(({ data }) => {
      if (!data) cached = null;
      return data ?? null;
    });
    void cached.then(setLookups);
  }, []);

  return lookups;
}
